module.exports = "/_next/static/images/discount-2b86bff354ffcb6a0a42da8aa36f78d3.jpg";